var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmeBusinessAccout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.00002V17M15 17V9.00002M5 9.00002V17M9 17V9.00002M3.68328 6.65838L10.6584 3.17084C11.5029 2.74855 12.4971 2.74855 13.3416 3.17084L20.3167 6.65838C20.7355 6.86776 21 7.29577 21 7.76396C21 8.44662 20.4466 9.00002 19.7639 9.00002H4.23607C3.55341 9.00002 3 8.44662 3 7.76396C3 7.29577 3.26452 6.86776 3.68328 6.65838ZM4.236 20H19.764C20.3721 20 20.8014 19.4043 20.6091 18.8275C20.2454 17.7361 19.2241 17 18.0737 17H5.92628C4.77592 17 3.75463 17.7361 3.39086 18.8275C3.19857 19.4043 3.62794 20 4.236 20Z",
    stroke: "#295B4A",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmeBusinessAccout);
export default __webpack_public_path__ + "static/media/sme-business-accout.a46177522a61f16b2b0362494c290652.svg";
export { ForwardRef as ReactComponent };